module.exports = __webpack_public_path__ + "img/menu-map-icon.fe0c8794.svg";